<template>
  <div
    id="dashboard"
    class="row w-100 pl-5 justify-content-start"
    :style="{
      //backgroundImage: `url(${require('@/assets/img/page_bg.png')})`,
      paddingRight: '0px',
      margin: '0px',
      padding: '0px !important',
    }"
  >
    <div class="container-fluid">
      <div>
        <div class="row">
          <div class="h3">API清單</div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-12 bd-callout bg-white">
            <div class="h5 mb-0 font-weight-bold text-primary">災害警報</div>
            <hr />
            <div class="row">
              <div class="col-12">
                <table :class="tableStyle">
                  <thead :class="tableThStyle">
                    <tr>
                      <th scope="col" width="10%">#</th>
                      <th scope="col" width="30%">類別</th>
                      <th scope="col" width="50%">API</th>
                      <!-- <th scope="col" width="10%">操作</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, key) in dashbords" :key="key">
                      <td :class="tableCenterStyle">{{ key + 1 }}</td>
                      <td :class="tableCenterStyle">{{ item.name }}</td>
                      <td v-html="item.url">{{ item.url }}</td>
                      <!-- <td :class="tableCenterStyle">
                        <button class="btn btn-info">說明</button>
                      </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
     

        <div class="row">
          <div class="col-sm-12 col-md-12 bd-callout bg-white">
            <div class="h5 mb-0 font-weight-bold text-primary">
              即時人流(推估)
            </div>
            <hr />
            <div class="row">
              <div class="col-12 h6">
                可參考交通部開放資料：
                <a
                  href="https://sheethub.com/data.gov.tw/%E6%94%BF%E5%BA%9C%E8%B3%87%E6%96%99%E9%96%8B%E6%94%BE%E5%B9%B3%E8%87%BA%E8%B3%87%E6%96%99%E9%9B%86%E6%B8%85%E5%96%AE/i/44/%E4%BA%A4%E9%80%9A%E9%83%A8"
                  >交通部資料</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Home",
  data() {
    return {
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      dashbords: [
        {
          name: "天氣描述資料: 多雲、晴、雨",
          url:
            "局屬氣象站資料(現在天氣觀測報告)-本局局屬有人氣象站資料 <br/> <br/>" +
            "https://opendata.cwb.gov.tw/api/v1/rest/datastore/O-A0001-001?Authorization=CWB-D3066267-E214-42D4-A558-5FA1D672787C&locationName=",
        },
        {
          name: "詳細天候資料",
          url:
            "自動氣象站資料-無人自動站氣象資料，WDSD：風速m/s 、TEMP：溫度 攝氏、HUMD：相對濕度 百分比、H_24R：日累積雨量 mm、H_FX：小時最大陣風 m/s <br/> <br/>" +
            "https://opendata.cwb.gov.tw/api/v1/rest/datastore/W-C0033-001?Authorization=CWB-D3066267-E214-42D4-A558-5FA1D672787C&locationName=",
        },
        {
          name: "天氣特報",
          url:
            "天氣特報-各別縣市地區目前之天氣警特報情形， 豪雨, 大豪雨, 超大豪雨, 陸上強風 <br/> <br/>" +
            "https://opendata.cwb.gov.tw/api/v1/rest/datastore/W-C0033-001?Authorization=CWB-D3066267-E214-42D4-A558-5FA1D672787C&locationName=",
        },
        {
          name: "地震資訊",
          url:
            "顯著有感地震報告 <br/><br/> " +
            "https://opendata.cwb.gov.tw/api/v1/rest/datastore/E-A0015-001?Authorization=CWB-D3066267-E214-42D4-A558-5FA1D672787C&areaName=",
        },
        {
          name: "浪高資訊(觀測)(主)",
          url:
            "長浪監測資料 <br/> <br/>" +
            "https://opendata.cwb.gov.tw/fileapi/v1/opendataapi/O-B0070-001?Authorization=CWB-D3066267-E214-42D4-A558-5FA1D672787C&downloadType=WEB&format=JSON",
        },
        {
          name: "備用浪高資訊(預報)(副)",
          url:
            "海面天氣預報 <br/><br/> " +
            "https://opendata.cwb.gov.tw/fileapi/v1/opendataapi/F-A0012-001?Authorization=CWB-D3066267-E214-42D4-A558-5FA1D672787C&downloadType=WEB&format=JSON",
        },
        {
          name: "颱風資訊",
          url:
            "颱風警報 -涵蓋本區、颱風警報-未涵蓋本區<br/><br/> " +
            "https://opendata.cwb.gov.tw/fileapi/v1/opendataapi/W-C0034-001?Authorization=CWB-D3066267-E214-42D4-A558-5FA1D672787C&downloadType=WEB&format=CAP",
        },
        {
          name: "取得花蓮風速預報資訊",
          url:
            "花蓮各地天氣 <br/><br/> " +
            "https://opendata.cwb.gov.tw/fileapi/v1/opendataapi/F-B0053-029?Authorization=CWB-D3066267-E214-42D4-A558-5FA1D672787C&downloadType=WEB&format=JSON",
        },
        {
          name: "取得台東風速預報資訊",
          url:
            "台東各地天氣 <br/> <br/>" +
            "https://opendata.cwb.gov.tw/fileapi/v1/opendataapi/F-B0053-047?Authorization=CWB-D3066267-E214-42D4-A558-5FA1D672787C&downloadType=WEB&format=JSON",
        },
        {
          name: "轄區車流API",
          url: "https://traffic.transportdata.tw/MOTC/v2/Road/Traffic/Live/VD/Highway/",
        },
      ],
    };
  },
  // components: { DialogModal },
  methods: {
    getTime: function () {
      return moment().subtract("-30", "s").format("YYYY/MM/DD HH:mm");
    },
    selectStreaming: function (item, dashboard) {
      this.$refs.streamingModal.openModal();
      this.selectItem = item;
      this.selectDashoard = dashboard;
    },
  },
};
</script>